import {
  ReadyWrap,
  ReadyInner,
  ReadyH2,
  ReadyP,
  ContactCard,
  ContactTitle,
  Form,
  Label,
  Input,
  Textarea,
  Full,
  SendRow,
  SendBtn,
} from "./Ready.styled";

export default function Ready() {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (typeof window !== "undefined" && "alert" in window) {
      window.alert("Thanks! We'll reach out soon.");
    }
  };

  return (
    <ReadyWrap id="ready">
      <ReadyInner>
        <ReadyH2>Ready to Digitalize Your Construction Operations?</ReadyH2>
        <ReadyP>
          Let's work together to transform your projects into a connected and
          sustainable digital ecosystem.
        </ReadyP>
        <ContactCard>
          <ContactTitle>Contact us</ContactTitle>
          <Form onSubmit={handleSubmit}>
            <Label>
              <span>Name</span>
              <Input placeholder="Your name" required />
            </Label>
            <Label>
              <span>Email</span>
              <Input type="email" placeholder="name@company.com" required />
            </Label>
            <Label>
              <span>Phone</span>
              <Input placeholder="Optional" />
            </Label>
            <Label>
              <span>Company</span>
              <Input placeholder="Your company" />
            </Label>
            <Full>
              <Label>
                <span>Message</span>
                <Textarea placeholder="Tell us what you're trying to fix" />
              </Label>
            </Full>
            <SendRow>
              <SendBtn type="submit">Send</SendBtn>
            </SendRow>
          </Form>
        </ContactCard>
      </ReadyInner>
    </ReadyWrap>
  );
}
